module.exports = __webpack_public_path__ + "static/img/tooth_currency@2x.390b6ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/Trauma/tooth_currency@2x.png
// module id = oAAa
// module chunks = 2